// extracted by mini-css-extract-plugin
export var activeDot = "_63-c";
export var buttonContainer = "_63-9";
export var channelButton = "_63-a";
export var clickable = "_63-d";
export var content = "_63-0";
export var contentFull = "_63-2";
export var contentThird = "_63-1";
export var contentWrapper = "_63-7";
export var description = "_63-5";
export var heightShort = "_63-f";
export var image = "_63-3";
export var imageContainer = "_63-4";
export var selectButton = "_63-e";
export var spinnerContainer = "_63-b";
export var titleContent = "_63-8";
export var titleWrapper = "_63-6";